module.exports = __webpack_public_path__ + "static/background-715270ce84d993952b69c3ce8222b34c.jpg";